import { getRecords, bySlug } from './baserow'

export default {
  getCourses () {
    return getRecords('Courses')
  },
  getCourse (slug) {
    return getRecords('Courses', bySlug(slug))
  }
}
